module.exports = __webpack_public_path__ + "img/reset-password-v2.7470943a.svg";